import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=0a0da501&scoped=true&"
import script from "./PersonalInformation.vue?vue&type=script&lang=js&"
export * from "./PersonalInformation.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInformation.vue?vue&type=style&index=0&id=0a0da501&lang=scss&scoped=true&"
import style1 from "./PersonalInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0da501",
  null
  
)

export default component.exports